"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeContractClient = void 0;
const protocol_core_1 = require("@moojo/protocol-core");
const accounts_1 = require("viem/accounts");
const viemChains = __importStar(require("viem/chains"));
const default_contract_client_1 = require("./impl/default-contract-client");
const sapphire_contract_client_1 = require("./impl/sapphire-contract-client");
// TODO: consider actual type args of transport, chain, account though WalletClient
const makeContractClient = async (privateKey, chainOrId, urlOrProvider) => {
    const account = (0, accounts_1.privateKeyToAccount)((0, protocol_core_1.hexify)(privateKey.toString()));
    const chain = typeof chainOrId === 'number' ? getViemChain(chainOrId) : chainOrId;
    if (chain.id === viemChains.sapphire.id || chain.id === viemChains.sapphireTestnet.id) {
        return (0, sapphire_contract_client_1.makeSapphireContractClient)(account, chain, urlOrProvider);
    }
    return (0, default_contract_client_1.makeDefaultContractClient)(account, chain, urlOrProvider);
};
exports.makeContractClient = makeContractClient;
const getViemChain = (chainId) => {
    const chain = Object.values(viemChains).find(c => c.id === chainId);
    if (chain) {
        return chain;
    }
    throw new Error(`Unsupported chainId '${chainId}'`);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udHJhY3QtY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnRyYWN0LWNsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLHdEQUErRDtBQUcvRCw0Q0FBbUQ7QUFDbkQsd0RBQXlDO0FBRXpDLDRFQUEwRTtBQUMxRSw4RUFBNEU7QUFJNUUsbUZBQW1GO0FBRTVFLE1BQU0sa0JBQWtCLEdBQUcsS0FBSyxFQUNyQyxVQUFzQixFQUN0QixTQUF5QixFQUN6QixhQUFvRCxFQUMzQixFQUFFO0lBQzNCLE1BQU0sT0FBTyxHQUFHLElBQUEsOEJBQW1CLEVBQUMsSUFBQSxzQkFBTSxFQUFDLFVBQVUsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFDLENBQUE7SUFFbEUsTUFBTSxLQUFLLEdBQUcsT0FBTyxTQUFTLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxZQUFZLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQTtJQUNqRixJQUFJLEtBQUssQ0FBQyxFQUFFLEtBQUssVUFBVSxDQUFDLFFBQVEsQ0FBQyxFQUFFLElBQUksS0FBSyxDQUFDLEVBQUUsS0FBSyxVQUFVLENBQUMsZUFBZSxDQUFDLEVBQUUsRUFBRSxDQUFDO1FBQ3RGLE9BQU8sSUFBQSxxREFBMEIsRUFBQyxPQUFPLEVBQUUsS0FBSyxFQUFFLGFBQWEsQ0FBQyxDQUFBO0lBQ2xFLENBQUM7SUFFRCxPQUFPLElBQUEsbURBQXlCLEVBQUMsT0FBTyxFQUFFLEtBQUssRUFBRSxhQUFhLENBQUMsQ0FBQTtBQUNqRSxDQUFDLENBQUE7QUFiWSxRQUFBLGtCQUFrQixzQkFhOUI7QUFFRCxNQUFNLFlBQVksR0FBRyxDQUFDLE9BQWUsRUFBRSxFQUFFO0lBQ3ZDLE1BQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsVUFBVSxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxPQUFPLENBQUMsQ0FBQTtJQUNuRSxJQUFJLEtBQUssRUFBRSxDQUFDO1FBQ1YsT0FBTyxLQUFLLENBQUE7SUFDZCxDQUFDO0lBRUQsTUFBTSxJQUFJLEtBQUssQ0FBQyx3QkFBd0IsT0FBTyxHQUFHLENBQUMsQ0FBQTtBQUNyRCxDQUFDLENBQUEifQ==